import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Backdrop,
  Fade,
  Button,
  TextField,
  useTheme,
  useMediaQuery,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { searchProcess } from "../services/clientService";
import { useUserStore } from "../store/userStore";
import { toast } from "react-toastify";
import { useSelectedItemStore } from "../store/useSelectedItemStore";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";

interface SearchProcessModalProps {
  open: boolean;
  onClose: () => void;
}

export const SearchProcessModal: React.FC<SearchProcessModalProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const profile = useUserStore((state) => state.profile);
  const clientId = useUserStore((state) => state.clientId);

  const modalStyle = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 704,
    height: "auto",
    maxHeight: 800,
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: 24,
    outline: "none",
    display: "flex",
    flexDirection: "column",
  };

  const [tipoBusca, setTipoBusca] = useState<number>(0);
  const [valorBusca, setValorBusca] = useState<string>("");
  const setSelectedItemId = useSelectedItemStore((s) => s.setSelectedItemId);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (tipoBusca && valorBusca) {
      try {
        const shouldPassClient = profile[0] === "cliente";

        const result = await searchProcess(
          tipoBusca as 1 | 2 | 3 | 4,
          valorBusca,
          shouldPassClient ? clientId : undefined
        );

        if (result && result.CD_PROCESSO) {
          onClose();
          setSelectedItemId(result.CD_PROCESSO);
          navigate(RoutesConfig.DETALHESPROCESSO.path);
        } else {
          toast.error("Nenhuma informação encontrada, verifique sua pesquisa!");
        }
      } catch (error) {
        console.error("Erro na busca:", error);
        toast.error("Nenhuma informação encontrada, verifique sua pesquisa!");
      }
    }
  };

  const cleanFilters = () => {
    setTipoBusca(0);
    setValorBusca("");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2,
              py: 1.5,
              backgroundColor: "#0A0C33",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            }}
          >
            <Typography variant="h5" color="#fff">
              Buscar Processo
            </Typography>
          </Box>

          <Box sx={{ p: 4 }}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              color="#0b0b33"
              mb={2}
            >
              Selecione a forma de Busca:
            </Typography>

            <FormControl component="fieldset">
              <RadioGroup
                row
                value={String(tipoBusca)}
                onChange={(e) => setTipoBusca(Number(e.target.value))}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: isMobile ? 0 : 1,
                }}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Número da DI"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Invoice"
                />
                <FormControlLabel
                  value="3"
                  control={<Radio />}
                  label="House B/L"
                />
                <FormControlLabel
                  value="4"
                  control={<Radio />}
                  label="Número do Container"
                />
              </RadioGroup>
            </FormControl>

            <TextField
              fullWidth
              variant="outlined"
              sx={{ mt: 3 }}
              value={valorBusca}
              onChange={(e) => setValorBusca(e.target.value)}
              placeholder="Digite o valor da busca"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              p: 2,
              borderTop: "1px solid #eee",
            }}
          >
            <Button
              size="large"
              variant="outlined"
              onClick={cleanFilters}
              sx={{
                textTransform: "none",
                borderRadius: "26px",
                border: "1px solid #0A0C33",
                color: "#0A0C33",
              }}
            >
              Limpar
            </Button>
            <Button
              size="large"
              variant="contained"
              onClick={handleSearch}
              sx={{
                textTransform: "none",
                backgroundColor: "#326AFD",
                borderRadius: "26px",
                fontWeight: 800,
              }}
              disabled={!tipoBusca || !valorBusca}
            >
              Buscar
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};
